module.exports = __webpack_public_path__ + "static/media/linked-account.10e28a6b.png";